import { doc, onSnapshot } from 'firebase/firestore';
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { db } from '../../firebase/config';
import './SignagePlayList.css';

const SignagePlayList = () => {
  const videoRefs = useRef([]);

  const [searchParams] = useSearchParams();
  const playListId = searchParams.get('id');
  const [playList, setPlayList] = useState([]);
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);

  const fetchPlayList = () => {
    if (!playListId) {
      console.error('No playlist ID found in search parameters.');
      return;
    }

    const playListRef = doc(db, 'playList', playListId);

    const unsubscribe = onSnapshot(
      playListRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          setPlayList({ id: docSnapshot.id, ...docSnapshot.data() });
        } else {
          console.error('No such playlist document exists.');
          setPlayList(null);
        }
      },
      (error) => {
        console.error('Error fetching playlist:', error);
      },
    );

    return () => unsubscribe();
  };

  useEffect(() => {
    fetchPlayList();
  }, [playListId]);

  useEffect(() => {
    if (playList?.assets?.length > 0) {
      let currentAsset =
        playList.assets[currentAssetIndex] || playList.assets[0];

      const timer = setTimeout(
        () => {
          setCurrentAssetIndex(
            (prevIndex) => (prevIndex + 1) % playList.assets.length,
          );
        },
        Number(currentAsset.duration) * 1000,
      );

      return () => clearTimeout(timer);
    }
  }, [currentAssetIndex, playList]);

  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index !== currentAssetIndex) {
          video.pause();
          video.currentTime = 0;
        } else {
          video.play();
        }
      }
    });
  }, [currentAssetIndex]);

  if (!playList?.assets?.length) {
    return <p>No assets available.</p>;
  }

  const getAssetUrl = (asset) => {
    if (asset.url && typeof asset.url === 'object') {
      return asset.url.url;
    }
    return asset.url;
  };

  return (
    <div className="container">
      {playList.assets.map((asset, index) => {
        const assetUrl = getAssetUrl(asset);
        return (
          <div
            key={index}
            className={`playlist-asset ${currentAssetIndex === index ? 'active' : ''}`}
            style={{ width: '100%', height: '100%' }}
          >
            {asset.assetType === 'image' && (
              <img
                src={assetUrl}
                alt={`Asset ${index}`}
                style={{ width: '100%', height: '100%', objectFit: 'fill' }}
              />
            )}
            {asset.assetType === 'link' && (
              <iframe
                src={assetUrl}
                title={`Asset ${index}`}
                style={{ width: '100%', height: '100%', border: 'none' }}
              ></iframe>
            )}
            {asset.assetType === 'video' && (
              <video
                ref={(el) => (videoRefs.current[index] = el)}
                src={assetUrl}
                autoPlay={currentAssetIndex === index}
                muted
                style={{ width: '100%', height: '100%', objectFit: 'fill' }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SignagePlayList;
